import { Component } from 'react';
import STELLA_logo from '@/assets/images/STELLA_logo.svg';
import STELLA_logo_vertical from '@/assets/images/STELLA_logo_vertical.svg';
import STELLA_logo_white from '@/assets/images/STELLA_logo_white.svg';

class SectionCont4 extends Component {
	render() {
		return (
			<section id="" className="sub-content cont4">
				<div className="sub-inner">
					<div className="sub-title">
						<strong className="title">CI소개</strong>
					</div>

					<div className="ci-box">
						<div className="title-box">
							<p className="title">로고마크</p>
							<div className="desc">
								<p>스텔라의 심벌마크는 3색(검정,주황,회색)을 기본으로 사용합니다.</p>
								<p>별처럼 빛나는 성공을 향해 함께 나아가는 비즈니스 파트너,</p>
								<p>
									스텔라는 고객에게 필요한 모든 정보와 솔루션을 제공하여 성공적인 비즈니스를 함께 만들어갈 것이라는
									열망을 담았습니다.
								</p>
							</div>
						</div>

						<div className="ci-type1 grid-box">
							<img src={STELLA_logo} alt="Stella logo" />
						</div>

						<div className="ci-type2">
							<div className="ci-list">
								<div className="title">세로형</div>
								<div className="grid-box">
									<img src={STELLA_logo_vertical} alt="Stella logo" />
								</div>
							</div>
							<div className="ci-list">
								<div className="title">응용형</div>
								<div className="bg-box">
									<img src={STELLA_logo_white} alt="Stella logo" />
								</div>
							</div>
						</div>
					</div>
					<div className="color-box">
						<div className="title-box">
							<p className="title">색상</p>
						</div>
						<div className="color-list">
							<ul>
								<li className="color1">
									<div className="desc">
										<p className="title">
											<span>기업의 품격</span>검정 (Black)
										</p>
										<p className="desc">C0 M0 Y0 K97</p>
										<p className="desc">#2D2A2B</p>
									</div>
								</li>
								<li className="color2">
									<div className="desc">
										<p className="title">
											<span>따뜻한 빛</span>주황 (Orange)
										</p>
										<p className="desc">C0 M60 Y95 K0</p>
										<p className="desc">#FF8500</p>
									</div>
								</li>
								<li className="color3">
									<div className="desc">
										<p className="title">
											<span>안정적인 성장</span>회색 (Gray)
										</p>
										<p className="desc">C0 M0 Y0 K60</p>
										<p className="desc">#898989</p>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</section>
		);
	}
}

export default SectionCont4;
